<template>
  <div class="overflow-hidden">
    <div
      class="flex items-center cursor-pointer px-2 py-1 hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors rounded-md group"
      @click="() => toggle()"
    >
      <div class="grow">
        <UiIcon icon="school" size="24" class="mr-3" />
        <span class="text-sm font-medium text-neutral-500">{{ data.titulo }}</span>
      </div>

      <div class="flex items-center text-sm gap-4 font-medium text-neutral-500">
        <!-- <div>{{ data.itens?.length }}</div>
        <div class="w-px bg-neutral-600 h-4"></div>
        <div class="w-16">{{ duration(data.cargaHoraria) }}</div> -->
        <CardTag
          v-if="data.itensDoCurso"
          icon="clock"
          no-shrink
          size="sm"
        >{{ duration(data.cargaHoraria) }}</CardTag>
        <CardTag
          icon="flag"
          type="neutral"
          no-shrink
          size="sm"
        >{{ data.itensDoCurso?.length }} {{ $t('labels.items') }}</CardTag>
        <CardTag 
          v-if="isBlocked" 
          type="availableat"
          no-shrink
          size="sm"
          icon-size="20px"
          :title="$t(`Disponível em: ${availableAt}`)"
          v-tooltip="{ placement: 'top' }"
        />

        <UiIcon
          icon="chevron-up"
          size="16"
          :class="['transition-transform', !visible ? 'group-hover:rotate-45' : 'rotate-180']"
        />
      </div>
    </div>
    <Transition
      mode="out-in"
      enter-active-class="transition ease-in-out transform"
      enter-from-class="-translate-x-full"
      leave-active-class="transition ease-in-out transform"
      leave-to-class="-translate-x-full"
    >
      <div v-if="visible" class="">
        <slot></slot>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { useToggle } from '@vueuse/core'
import { duration } from '@/common/util'

import UiIcon from '@/components/ui/icon.vue'
import CardTag from './cardTag.vue'

const { 
  data,
  isBlocked = false,
  availableAt = ''
} = defineProps<{
  data: any
  isBlocked?: boolean
  availableAt?: string
}>()

const [visible, toggle] = useToggle()

const calcDuration = (items: any[]) => {
  let total = 0

  items?.forEach((item) => {
    if (item.duracao) {
      const parts = item.duracao.split(':').map(Number)
      if (parts.length === 3) {
        total += parts[0] * 3600 + parts[1] * 60 + parts[2]
      } else if (parts.length === 2) {
        total += parts[0] * 60 + parts[1]
      }
    }
  })

  return total > 0 ? total : '-'
}
</script>
